__webpack_require__.p = "https://assets-01.periodica.press/5da9759-20437459122/";